module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Xt2BxP/media/FC-9789948778011.jpg?1708094060567",
      "alt": "This image is the cover for the book Mindful Futurism: Paving the Way for Future Generations"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Mindful Futurism: Paving the Way for Future Generations\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("What is the common root of the most significant crises facing humanity today? And what is a simple, universal tool both individuals and businesses can apply to create the most leverage for positive change? These are the two urgent questions at the heart of this book. Spurred by a turbulent entry into fatherhood, the author walks readers through his rude awakening to the state of the modern world, into the deeper realization of the flawed mindset threatening our future – and the universal system he devised to remedy it. Relevant to both citizens and CEO’s, Mindful Futurism offers a critical tool at a time we need it most: a compact and memorable framework to guide our decision-making processes; designed to ensure the security and wellbeing of humanity for centuries to come.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Rakan Brahedni\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Rakan Brahedni is a technologist, futurist, certified health coach, and father-of-two on a mission to inspire others to live more mindful and meaningful lives with the hope of building a better world for future generations. He and his family reside in Dubai where he is currently working on his second book.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0